// extracted by mini-css-extract-plugin
module.exports = {"browsePage":"BrowsePage_browsePage__mWcWK"};